import { mapActions } from 'vuex';
import notificationProxy from '@/services/notifications/proxy';


export default {
  methods: {
    ...mapActions('popup', ['setCurrentSmallPopup']),
    onOptIn() {
      notificationProxy.optInMessaging();
      notificationProxy.setupMessaging();
      this.setCurrentSmallPopup();
    },
    onOptOut() {
      notificationProxy.optOutMessaging();
      this.setCurrentSmallPopup();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/messaging-journey-info/messaging-journey-info.js